import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../modules/tcm-core.module';

@Injectable({
  providedIn: 'root'
})
export class InvoiceSectionTemplateDataService {
  constructor(private readonly httpClient: ApiHttpClient) {
  }

  public getActiveBrandsAsync(isNetwork: boolean, timeout: Promise<any>): Promise<number[]> {
    return this.httpClient.getJsonAsync<number[]>('InvoiceSectionTemplates/GetActiveBrands', { isNetwork }, timeout, false);
  }
}
